import { Arr_SEFPages } from "../../../../arrays/SEF/Arr_SEFPages";
import getNestedPropByID from "../../../../functions/getNestedPropByID";

function ConsultantBookingCards({
  Arr_Bookings,
  Arr_BasicSEFPages,
  Arr_AdvancedSEFPages,
  countUnpaidInvoices,
  checkSEFProgress,
  screenWidth,
  handleExpand,
  handleOpenSEFPage,
  obj_EC,
  Arr_ECs,
  handleSendSEFPage,
}) {
  const basicSEFPages = Arr_SEFPages.filter(
    (obj_SEFPage) => obj_SEFPage.level === "Basic"
  );

  const advSEFPages = Arr_SEFPages.filter(
    (obj_SEFPage) => obj_SEFPage.level === "Advanced"
  );

  return (
    <div
      class="w3-row-padding w3-center w3-padding-64 w3-theme-l5"
      id="pricing"
    >
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        {Arr_Bookings.map((obj_booking, index) => (
          <div
            class="w3-third w3-margin-bottom"
            style={{
              width: screenWidth === "Small" ? "100%" : "",
            }}
          >
            <ul class="w3-ul w3-border w3-hover-shadow">
              <li class="w3-theme">
                <p class="w3-large">
                  {obj_booking.BasicInfo?.First_Name || ""}{" "}
                  {obj_booking.BasicInfo?.Last_Name || ""}
                  {obj_EC.MetaData?.Admin === "Yes" ? (
                    <>
                      , Booking made by{" "}
                      {getNestedPropByID(
                        Arr_ECs,
                        obj_booking.IPInfo?.EC_ID,
                        "First_Name",
                        "BasicInfo"
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </p>
              </li>
              <li class="w3-padding-16">
                {obj_booking.BasicInfo?.ProgrammeTitle || ""}
              </li>
              <li class="w3-padding-8">
                {obj_booking.BasicInfo?.ProgrammeDate || ""}
              </li>
              <li class="w3-padding-8">
                {" "}
                {obj_booking.BasicInfo?.ProgrammeVarient || ""}
              </li>
              <li class="w3-padding-8">
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <h4
                    style={{
                      backgroundColor: "rgba(209, 18, 18, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Registration Cancelled
                  </h4>
                ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                  <h4
                    style={{
                      backgroundColor: "rgba(8, 83, 182, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Registration Reserved
                  </h4>
                ) : (
                  <h4
                    style={{
                      backgroundColor: "rgba(6, 134, 47, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Registration Confirmed
                  </h4>
                )}
              </li>

              {obj_booking.MetaData?.Archived === "Yes" ? (
                <></>
              ) : (
                <>
                  <li class="w3-padding-8">
                    <div
                      style={{
                        width: "50%",
                        marginLeft: "25%",
                        marginRight: "25%",
                      }}
                    >
                      {countUnpaidInvoices(obj_booking)}
                    </div>
                  </li>
                </>
              )}
              {obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                "weekend"
              ) ? (
                <li class="w3-padding-8">Weekend Booking</li>
              ) : (
                <div>
                  <li class="w3-padding-8">
                    <span class="w3-opacity">
                      Student Enrollment Form Progress:
                    </span>
                    <h3
                      class="ProgressBox"
                      className={`ProgressBox ${
                        obj_booking.SEFInfo?.SEF === "Complete"
                          ? "Complete"
                          : obj_booking.SEFInfo?.SEF === "In Progress"
                          ? "In_Progress"
                          : obj_booking.SEFInfo?.SEF === "Awaiting Review"
                          ? "Awaiting_Review"
                          : "Incomplete"
                      }`}
                      style={{
                        width: "50%",
                        textAlign: "center",
                        marginLeft: "25%",
                        marginRight: "25%",
                      }}
                    >
                      {obj_booking.SEFInfo && obj_booking.SEFInfo?.SEF
                        ? obj_booking.SEFInfo?.SEF.replaceAll("_", " ")
                        : "Incomplete"}
                    </h3>
                    <span class="w3-opacity">Sections:</span>
                  </li>
                  <li
                    class="w3-padding-8"
                    className={`ProgressBox ${
                      checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                      "Complete"
                        ? "Complete"
                        : checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                          "In Progress"
                        ? "In_Progress"
                        : checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                          "Awaiting Review"
                        ? "Awaiting_Review"
                        : "Incomplete"
                    }`}
                    style={{
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Basic Information:{" "}
                    {checkSEFProgress(obj_booking, Arr_BasicSEFPages)}
                  </li>
                  <li
                    class="w3-padding-8"
                    className={`ProgressBox ${
                      checkSEFProgress(obj_booking, Arr_AdvancedSEFPages) ===
                      "Complete"
                        ? "Complete"
                        : checkSEFProgress(
                            obj_booking,
                            Arr_AdvancedSEFPages
                          ) === "In Progress"
                        ? "In_Progress"
                        : checkSEFProgress(
                            obj_booking,
                            Arr_AdvancedSEFPages
                          ) === "Awaiting Review"
                        ? "Awaiting_Review"
                        : "Incomplete"
                    }`}
                    style={{
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Medical Questions:{" "}
                    {checkSEFProgress(obj_booking, Arr_AdvancedSEFPages)}
                  </li>

                  <li class="w3-padding-8">
                    <button
                      class="w3-button w3-teal w3-padding-large"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                      onClick={(e) => handleExpand(e, obj_booking)}
                    >
                      {obj_booking.Expand === "Yes" ? (
                        <>
                          Shrink
                          <i
                            class="fa fa-long-arrow-up"
                            style={{ marginLeft: "10px" }}
                          ></i>
                        </>
                      ) : (
                        <>
                          Expand
                          <i
                            class="fa fa-long-arrow-down"
                            style={{ marginLeft: "10px" }}
                          ></i>
                        </>
                      )}
                    </button>
                  </li>
                  {obj_booking.Expand === "Yes" ? (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {/* All Basic Stuff */}
                      <div style={{ width: "48%" }}>
                        {basicSEFPages.map((obj_SEFPage, index) => (
                          <li class="w3-padding-8">
                            <>{obj_SEFPage.label}</>
                            <div
                              className={`ProgressBox ${
                                obj_booking.SEFProgress?.[obj_SEFPage.Prop] ===
                                "Complete"
                                  ? "Complete"
                                  : obj_booking.SEFProgress?.[
                                      obj_SEFPage.Prop
                                    ] === "In_Progress"
                                  ? "In_Progress"
                                  : obj_booking.SEFProgress?.[
                                      obj_SEFPage.Prop
                                    ] === "Awaiting_Review"
                                  ? "Awaiting_Review"
                                  : "Incomplete"
                              }`}
                            >
                              {obj_booking.SEFProgress &&
                              obj_booking.SEFProgress[obj_SEFPage.Prop]
                                ? obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                  "Complete"
                                  ? "Complete"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "In_Progress"
                                  ? "In Progress"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "Incomplete"
                                  ? "Incomplete"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "Awaiting_Review"
                                  ? "Awaiting Review"
                                  : "Incomplete"
                                : "Incomplete"}
                            </div>
                            {obj_booking.IPInfo?.EC_ID === obj_EC._id ? (
                              <button
                                onClick={(e) =>
                                  handleOpenSEFPage(e, obj_booking, obj_SEFPage)
                                }
                              >
                                Go To{" "}
                              </button>
                            ) : (
                              "Only Accessable by Parents/ Legal Guardians and " +
                              getNestedPropByID(
                                Arr_ECs,
                                obj_booking.IPInfo?.EC_ID,
                                "First_Name",
                                "BasicInfo"
                              )
                            )}
                          </li>
                        ))}
                        {/* Show the arrival/ departure status for accom only */}
                        {obj_booking.BasicInfo?.ProgrammeVarient &&
                        obj_booking.BasicInfo?.ProgrammeVarient.toLowerCase().includes(
                          "accom"
                        ) ? (
                          <li class="w3-padding-8">
                            <>Arrival/ Departure Info</>
                            <div
                              className={`ProgressBox ${
                                obj_booking.SummerArrivalDeparture?.Progress ===
                                "Complete"
                                  ? "Complete"
                                  : obj_booking.SummerArrivalDeparture
                                      ?.Progress === "In_Progress"
                                  ? "In_Progress"
                                  : obj_booking.SummerArrivalDeparture
                                      ?.Progress === "Awaiting_Review"
                                  ? "Awaiting_Review"
                                  : "Incomplete"
                              }`}
                            >
                              {obj_booking.SummerArrivalDeparture &&
                              obj_booking.SummerArrivalDeparture?.Progress
                                ? obj_booking.SummerArrivalDeparture
                                    ?.Progress === "Complete"
                                  ? "Complete"
                                  : obj_booking.SummerArrivalDeparture
                                      ?.Progress === "In_Progress"
                                  ? "In Progress"
                                  : obj_booking.SummerArrivalDeparture
                                      ?.Progress === "Incomplete"
                                  ? "Incomplete"
                                  : obj_booking.SummerArrivalDeparture
                                      ?.Progress === "Awaiting_Review"
                                  ? "Awaiting Review"
                                  : "Incomplete"
                                : "Incomplete"}
                            </div>

                            {obj_booking.IPInfo?.EC_ID === obj_EC._id ? (
                              <button
                                onClick={(e) =>
                                  handleOpenSEFPage(e, obj_booking, {
                                    link: "ArrivalDeparture",
                                  })
                                }
                              >
                                Go To{" "}
                              </button>
                            ) : (
                              "Only Accessable by Parents/ Legal Guardians and " +
                              getNestedPropByID(
                                Arr_ECs,
                                obj_booking.IPInfo?.EC_ID,
                                "First_Name",
                                "BasicInfo"
                              )
                            )}
                          </li>
                        ) : (
                          <></>
                        )}
                      </div>{" "}
                      {/* Parent Stuff Only */}
                      <div style={{ width: "48%" }}>
                        <br></br>
                        <h4>
                          <u>Parents/ Legal Guardians Only</u>
                        </h4>
                        {advSEFPages.map((obj_SEFPage, index) => (
                          <li class="w3-padding-8">
                            <>{obj_SEFPage.label}</>
                            <div
                              className={`ProgressBox ${
                                obj_booking.SEFProgress?.[obj_SEFPage.Prop] ===
                                "Complete"
                                  ? "Complete"
                                  : obj_booking.SEFProgress?.[
                                      obj_SEFPage.Prop
                                    ] === "In_Progress"
                                  ? "In_Progress"
                                  : obj_booking.SEFProgress?.[
                                      obj_SEFPage.Prop
                                    ] === "Awaiting_Review"
                                  ? "Awaiting_Review"
                                  : "Incomplete"
                              }`}
                            >
                              {obj_booking.SEFProgress &&
                              obj_booking.SEFProgress[obj_SEFPage.Prop]
                                ? obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                  "Complete"
                                  ? "Complete"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "In_Progress"
                                  ? "In Progress"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "Incomplete"
                                  ? "Incomplete"
                                  : obj_booking.SEFProgress[
                                      obj_SEFPage.Prop
                                    ] === "Awaiting_Review"
                                  ? "Awaiting Review"
                                  : "Incomplete"
                                : "Incomplete"}
                            </div>
                          </li>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}

                  {obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                    "weekend"
                  ) ? (
                    <></>
                  ) : (
                    <li class="w3-padding-8">
                      <button
                        class=" w3-padding-large"
                        style={{
                          textAlign: "center",
                          width: "70%",
                          marginLeft: "15%",
                          marginRight: "15%",
                        }}
                        onClick={(e) => handleSendSEFPage(e, obj_booking)}
                      >
                        Email Safeguarding Enrolment Form to Parents/Student
                      </button>
                    </li>
                  )}
                </div>
              )}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConsultantBookingCards;
